// extracted by mini-css-extract-plugin
export default {"ratingImg":"CustomRating_ratingImg__tnduF","CustomRatingBarStyle":"CustomRating_CustomRatingBarStyle__Pz1N3"};